import React from 'react';

const Denmark = (props) => (
<img src="https://flagsapi.com/DE/flat/64.png"/>
);

export default Denmark;



